import script from "./SidebarNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarNavigation.vue?vue&type=script&setup=true&lang=js"

import "./SidebarNavigation.vue?vue&type=style&index=0&id=6bc6ded2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bc6ded2"]])

export default __exports__